import { render, staticRenderFns } from "./CItemContract.vue?vue&type=template&id=13dcddbe"
import script from "./CItemContract.vue?vue&type=script&lang=js"
export * from "./CItemContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports